import { memo, useEffect, useState } from 'react';
import Lottie from 'react-lottie';
// LoadingAnimation is fetched from public assets to avoid embedded data: URIs
// that would require allowing data: in CSP. The build script extracts images
// to `public/assets/loading/` and writes a referential JSON there.
import Box from '@mui/material/Box';

function dataURLToBlob(dataurl: string) {
  const parts = dataurl.split(',');
  const meta = parts[0];
  const base64 = parts[1] || '';
  const m = meta.match(/:(.*?);/);
  const mime = m ? m[1] : 'application/octet-stream';
  const binary = atob(base64);
  const len = binary.length;
  const u8 = new Uint8Array(len);
  for (let i = 0; i < len; i++) u8[i] = binary.charCodeAt(i);
  return new Blob([u8], { type: mime });
}


export const SplashScreen: React.FC = memo(() => {
  const [animationData, setAnimationData] = useState<any>(null);

  useEffect(() => {
    let mounted = true;
    const cacheBuster = process.env.NODE_ENV === 'development' ? `?ts=${Date.now()}` : '';
    fetch('/assets/loading/loading.json' + cacheBuster)
      .then((r) => {
        if (!r.ok) throw new Error('Failed to load Lottie JSON');
        return r.json();
      })
      .then((json) => {
        if (!mounted) return;
        setAnimationData(json);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error('Failed to fetch Lottie animation:', err);
      });
    return () => {
      mounted = false;
    };
  }, []);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData || undefined,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  return (
    <Box display='flex' justifyContent='center' justifyItems='center' height='100vh' >
      <Box display='flex' alignSelf='center'>
        {animationData ? (
          <Lottie options={defaultOptions} height={200} width={200} />
        ) : null}
      </Box>
    </Box>
  );
});